<template>
  <v-textarea
    :clearable="canClear"
    :filled="filled"
    v-model="data"
    :auto-grow="grow"
    :counter="counter"
    @input="handleInput"
  >
    <template #label v-if="fieldLabel">
      {{ full_label }}
    </template>
  </v-textarea>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { computed, ref, onMounted } from "vue";

  // Define the properties
  const props = defineProps({
    config: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    value: {
      type: [String, Number, Array],
    },
  });

  // Define emits
  const emit = defineEmits(["input"]);

  // Define the data field for the filed contents
  let data = ref(null);

  // Set the initial data of the text field
  onMounted(() => {
    data.value = props?.value
  })

  // Handle the user text input
  const handleInput = (value) => {
    emit("input", value);
  };

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  // Visual Settings
  const filled = computed(() => propCheck("filled", false));
  const grow = computed(() => propCheck("grow", false));
  const counter = computed(() => propCheck("counter", undefined));
  const canClear = computed(() => propCheck("clear", false));
  const fieldLabel = computed(() => propCheck("label", false));

  // Label Settings
  const full_label = computed(() => {
    if (!check.isUndefined(props.label)) return props.label;
    return "";
  });
</script>
